module.exports = __webpack_public_path__ + "static/media/create_01.b2ef7a20.png";